<mat-card class="product-search content">
  @if (!preDefinedFilter) {
    <div class="product-search__head">
      <div class="product-search__title">
        <h1 class="title">
          {{ keyword }}
        </h1>
      </div>
      <span class="spacer"></span>
      <div class="product-search__count">
        {{ paging.total }} item{{ paging.total === 1 ? "" : "s" }}
      </div>
    </div>
  }
  @if (preDefinedFilter) {
    <div class="product-search__head">
      <div class="product-search__title" style="width: 300px">
        <h1 class="title">Global Filter Search</h1>
      </div>
      <span class="spacer"></span>
      @if (authService.hasPermission(Permission.ProductsWorkflowFilter)) {
        <app-dynamic-chip-set
          style="width: 100%"
          [chips]="preDefinedFilters"
          [selectedChipKey]="key"
          [loading]="isLoading"
          [flexEnd]="true"
          (chipSelected)="onPreDefinedFilterChange($event)"
          >
        </app-dynamic-chip-set>
      }
      <br />
    </div>
  }

  @if (!isLoading) {
    <div class="content-container">
      @if (listProduct.length > 0) {
        <div
          #pdList
          class="product-search__list"
          (scroll)="onScroll($event)"
          >
          <mat-grid-list [cols]="colPerScreen" [rowHeight]="'1:1'" gutterSize="10">
            @for (item of listProduct; track item) {
              <mat-grid-tile [colspan]="1">
                <div class="product-search__item" #pdItem>
                  <app-product-search-item
                    [data]="item"
                    [filter]="preDefinedFilter"
                  ></app-product-search-item>
                </div>
              </mat-grid-tile>
            }
          </mat-grid-list>
        </div>
      } @else {
        <div class="product-search__no-data">
          <img
            class="product-search__no-data-img"
            [src]="'assets/no-data-product.svg'"
            alt="No Data"
            matTooltipPosition="above"
            />
          @if (!preDefinedFilter) {
            <div class="product-search__no-data-label">
              We couldn’t find anything matching your search.
            </div>
          }
          @if (!preDefinedFilter) {
            <div
              class="product-search__no-data-description"
              >
              Try again with a different term
            </div>
          }
          @if (preDefinedFilter) {
            <div class="product-search__no-data-label">
              No filter selected, please select before searching.
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <div class="loading-overlay">
      <mat-spinner></mat-spinner>
    </div>
  }

  @if (preDefinedFilter) {
    <div class="product-search__count">
      <span class="spacer"></span>
      {{ paging.total }} item{{ paging.total === 1 ? "" : "s" }}
    </div>
  }


</mat-card>
